export default __webpack_public_path__ + "static/media/longActive.893975d8.svg";